import { take, call, put, fork } from 'redux-saga/effects';
import {
  putData,
  failPutData,
  successPutData,
  checkEmail,
  failCheckEmail,
  successCheckEmail,
  checkUser,
  successCheckUser,
  failCheckUser,
  setData,
  reAnswer,
  successReanswer,
  failReAnswer,
} from '../actions/exam';
import superFetch from '../modules/superFetch';
import { push } from 'connected-react-router';

export function* handlePutData() {
  while (true) {
    const actions = yield take(`${putData}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/exam/putdata',
      type: 'POST',
      data: actions.payload,
    });

    if (payload && !err) {
      yield put(successPutData({}));
      yield put(push('/exam/complete'));
      continue;
    }

    if (!payload && err) {
      document.getElementById('form-container').scrollTop = 0;
      yield put(failPutData(String(err)));
      continue;
    }
  }
}
export function* handleCheckEmail() {
  while (true) {
    const action = yield take(`${checkEmail}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/exam/checkemail',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successCheckEmail(payload));
      yield put(push('/exam/authcode'));
      continue;
    }

    if (!payload && err) {
      yield put(failCheckEmail(String(err)));
      continue;
    }
  }
}
export function* handleReanswer() {
  while (true) {
    const action = yield take(`${reAnswer}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/exam/reanswer',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successReanswer(payload));
      yield put(push('/exam/recomplete'));
      continue;
    }

    if (!payload && err) {
      yield put(failReAnswer(String(err)));
      continue;
    }
  }
}

export function* handleCheckUser() {
  while (true) {
    const action = yield take(`${checkUser}`);
    const { payload, err } = yield call(superFetch, {
      url: '/api/exam/checkuser/',
      type: 'POST',
      data: action.payload,
    });

    if (payload && !err) {
      yield put(successCheckUser(payload));
      if (payload.data) {
        let data = [];
        payload.data.forEach((category) => {
          if (category.data) {
            let tempItem = { data: [] };
            category.data.forEach((value) => {
              let tempValue = { data: undefined };
              tempValue.data = value.data.toString();
              tempItem.data.push(tempValue);
            });
            data.push(tempItem);
          }
        });
        yield put(setData({ data: data }));
        yield put(push('/exam/recomplete'));
        continue;
      }
      yield put(push('/exam'));
      continue;
    }

    if (!payload && err) {
      yield put(failCheckUser(String(err)));
      continue;
    }
  }
}
//作った関数をまとめて form 関数名 saga() の変更は必要無し。
export default function* saga() {
  yield fork(handlePutData);
  yield fork(handleReanswer);
  yield fork(handleCheckEmail);
  yield fork(handleCheckUser);
}



// WEBPACK FOOTER //
// ./src/sagas/exam.js